import { ChannelRecord } from "./types";
import {
	Datagrid,
	EditButton,
	ReferenceField,
	ReferenceManyField,
	Show,
	SimpleShowLayout,
	Tab,
	TabbedShowLayout,
	TextField,
	TopToolbar,
	useRecordContext,
} from "react-admin";
import { RemoveWithConfirmButton } from "../../components/RemoveWithConfirmButton";
import { UserName } from "../../components/UserName";
import { useOrganPermission } from "../../permissions";

const ChannelShowActions = () => {
	const channel = useRecordContext();
	const { hasPermissionInOrgan } = useOrganPermission("channels.update");
	if (!channel) return null;

	return (
		<TopToolbar>
			{hasPermissionInOrgan(channel.organ_id) && <EditButton />}
		</TopToolbar>
	);
};

const UserChannelList = () => {
	const channel = useRecordContext<ChannelRecord>();

	const { hasPermissionInOrgan } = useOrganPermission("channel-users.delete");

	if (!channel) return null;

	return (
		<SimpleShowLayout>
			<ReferenceField source="organ_id" reference="organs" link="show">
				<TextField source="name" />
			</ReferenceField>
			<TextField source="name" label="Channel name" />
			<TabbedShowLayout>
				<Tab label="Users">
					<ReferenceManyField
						label=""
						reference="channel-users"
						target="channel_id"
					>
						<Datagrid
							bulkActionButtons={false}
							rowClick={(id, resource, record) =>
								`/users/${record.user_id}/show`
							}
						>
							<ReferenceField
								source="user_id"
								reference="users"
								link="show"
								label="Name"
							>
								<UserName />
							</ReferenceField>
							{hasPermissionInOrgan(channel.organ_id) ? (
								<RemoveWithConfirmButton
									confirmContent="Are you sure you want to remove this user from the channel?"
									notifyMessage="User removed from channel"
								/>
							) : null}
						</Datagrid>
					</ReferenceManyField>
				</Tab>
			</TabbedShowLayout>
		</SimpleShowLayout>
	);
};

export const ChannelShow = () => (
	<Show title="Channel view" actions={<ChannelShowActions />}>
		<UserChannelList />
	</Show>
);
